import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl: string = `${environment.serverBaseUrl}/auth`;

  constructor(private http: HttpClient) { }

  /**
   * Trata a criação da conta do usuário.
   * @param secretKey Chave secreta para garantir que somente pessoas autorizadas se cadastrem
   * @param email email do usuário
   * @param password senha do usuário
   * @returns 
   */
  register(secretKey: string, email: string, password: string) {
    interface RegisterResponse {
      success: boolean,
      message: string,
      data: { id: number, email: string, },
    }
    return this.http.post<RegisterResponse>(`${this.baseUrl}/register`, { secretKey, email, password });
  }

  /**
   * Trata o login do usuário.
   * @param email email do usuário previamente cadastrado
   * @param password senha do usuário
   */
  login(email: string, password: string): Observable<{}> {
    return this.http.post(`${this.baseUrl}/login`, { email, password })
      .pipe(
        catchError(this.handleError)
      );
  }

  /**
   * Trata o logout do usuário
   * @returns 
   */
  logout() {
    localStorage.removeItem('userInfo');
    return this.http.get(`${this.baseUrl}/logout`)
      .pipe(
        catchError(this.handleError)
      );
  }

  /**
   * Verifica se o usuário está autenticado ou não
   * @returns booleano que indica se o usuário está autenticado ou não
   */
  isAuthenticated(): boolean {

    const userData = localStorage.getItem('userInfo');
    if (userData && JSON.parse(userData)) {
      return true;
    }

    return false;
  }

  /**
   * Verifica se o usuário conectado tem role admin
   * @returns true se o usuário for admin, false caso contrário.
   */
  isAdmin(): boolean {
    const userData = localStorage.getItem('userInfo');
    if (userData) {
      let userJson = JSON.parse(userData);
      return userJson['role'] == 'admin';
    }
    return false;
  }

  /**
   * 
   * @param user 
   */
  setUserInfo(user: any) {
    localStorage.setItem('userInfo', JSON.stringify(user));
  }

  /**
   * 
   * @param status 
   */
  static getErrorText(status: number): string {

    const errors : { [key: number]: string } = {
      401: 'E-mail ou senha inválidos.',
    };

    return (status in errors) ? errors[status] : 'Ocorreu um erro. Tente novamente mais tarde.';
  }

  /**
   * 
   * @param error 
   */
  private handleError(error: HttpErrorResponse) {
    console.log(error);
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      // console.error(AuthService.getErrorText(error.status));
    }
    // Return an observable with a user-facing error message.
    return throwError(AuthService.getErrorText(error.status));
  }
}
